import { render, staticRenderFns } from "./SendReview.vue?vue&type=template&id=5ed3be5a"
import script from "./SendReview.vue?vue&type=script&lang=js"
export * from "./SendReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports